import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getResidentialFaqQuestions = (siteTitle, vehicleType) => [
  {
    question: `How do food ${vehicleType}s work at apartment complexes and HOA communities?`,
    answer: `A ${vehicleType} visits on a set schedule and sells dinner or lunch to residents. We build and manage the rotation, handle scheduling, and keep you and the ${vehicleType}s in the loop. Each ${vehicleType} arrives self-contained, serves on site, and leaves with nothing for your staff to clean up.`
  },
  // Pricing per the client (4 Sep 2026) and the 7 Sep owner decision: hosted
  // service is a program fee quoted up front, self-serve through the catering
  // form carries no program fee, and no price list is published. Same answer
  // as the page's "What it costs" card.
  {
    question: `Does it cost apartment communities anything to host food ${vehicleType}s?`,
    answer: `Most properties have us run it. Hosted service is a monthly program fee we quote up front, and we handle the schedule, the ${vehicleType}s, and the day-of details. Residents buy their own dinner at the ${vehicleType}; a resident credit or a sponsored night is optional. Prefer to run it yourself? Submit a recurring request through the catering form and pick your own ${vehicleType}s. There's no program fee that way.`
  },
  {
    question: `How often can food ${vehicleType}s visit my apartment or neighborhood?`,
    answer: `Weekly, every other week, monthly, or on a rotation, depending on the size of the community and how residents respond. A consistent night works best so residents know when to expect a ${vehicleType}. We can adjust the rotation based on what residents order.`
  },
  {
    question: `Do residents need to pre-order food from the ${vehicleType}s?`,
    answer: `No. Residents order at the ${vehicleType} when it arrives, and many ${vehicleType}s also take online orders so people can skip the line. A weekly menu email and a community page show which ${vehicleType}s are coming.`
  },
  {
    question: `What space or setup is required to host a food ${vehicleType}?`,
    answer: `A designated parking or loading area, roughly 30 ft by 8 ft. Most ${vehicleType}s bring their own power and water and don't need indoor space. If access, power, or traffic flow is a question, we'll work it out with you before the first visit.`
  },
  {
    question: `Why are food ${vehicleType}s a good amenity for apartment communities?`,
    answer: `Residents get dinner without leaving the property, neighbors run into each other, and you get an amenity that doesn't need staff or a budget line. Local ${vehicleType}s get a regular stop.`
  }
];

function ResidentialFaq() {
  const { site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getResidentialFaqQuestions(site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default ResidentialFaq;
